var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svgicon',{class:( _obj = {}, _obj[_vm.$options.name] = true, _obj[((_vm.$options.name) + "--" + _vm.size)] = _vm.size, _obj ),attrs:{"original":_vm.original,"color":_vm.color,"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }